export const Breakpoints = {
  width: {
    xxs: 320,
    xs: 375,
    s: 425,
    m: 768,
    l: 1024,
    xl: 1440,
    xxl: 1920,
  },
  height: {
    xxs: 240,
    xs: 360,
    s: 480,
    m: 600,
    l: 768,
    xl: 900,
    xxl: 1080,
  },
};
